<template>
  <div>
    <Modal
      ref="modal"
      title="Add cities"
      action="Save"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleCreate"
    >
      <CitiesInput v-model="selectedCities" label="Location" />
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import StatesUtility from '../../utilities/states.js';
import CitiesInput from '../shared/CitiesInput.vue';
import { createJobLocation } from '../../api/jobs.ts';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    Modal,
    CitiesInput,
  },
  props: {
    record: Object,
    initialCities: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      selectedCities: [],
      states: StatesUtility.getStates(),
    };
  },
  methods: {
    isDuplicateCity(newCity) {
      return this.initialCities.some(
        existingCity =>
          existingCity.city.toLowerCase() === newCity.city.toLowerCase() &&
          existingCity.state.toLowerCase() === newCity.state.toLowerCase()
      );
    },
    validateLocation() {
      const duplicates = this.selectedCities.filter(city => this.isDuplicateCity(city));
      if (duplicates.length > 0) {
        toast.error('Duplicate cities detected', {
          action: { label: 'Dismiss' },
          description: `The following cities are already added to this job: ${duplicates
            .map(c => `${c.city}, ${c.state}`)
            .join(', ')}`,
        });
        return false;
      }
      return true;
    },
    async handleCreate() {
      if (!this.selectedCities.length) {
        this.loadingSpinnerStore.hideLocalLoadingSpinner();
        return;
      }
      if (!this.validateLocation()) {
        this.handleValidationError();
        return;
      }

      try {
        const promises = this.selectedCities.map(city =>
          createJobLocation(
            { id: this.record.id },
            {
              newJobLocationAttributes: {
                city: city.city,
                state: city.state,
                country: city.country || 'USA',
                latitude: city.latitude,
                longitude: city.longitude,
                status: 'active',
              },
            }
          )
        );

        await Promise.all(promises);
        this.handleSuccess();
      } catch (error) {
        this.handleError();
      }
    },
    handleValidationError() {
      if (this.$refs.modal && typeof this.$refs.modal.error === 'function') {
        this.$refs.modal.error();
      } else {
        this.loadingSpinnerStore.hideLocalLoadingSpinner();
      }
    },
    handleSuccess() {
      if (this.$refs.modal && typeof this.$refs.modal.success === 'function') {
        this.$refs.modal.success();
      } else {
        this.loadingSpinnerStore.hideLocalLoadingSpinner();
      }

      this.$emit('handleJobCityNewCreate');
      toast.success('Job city/cities added', {
        action: { label: 'Dismiss' },
        description:
          'Your city/cities were successfully added. Use the buttons below to view your job, or dismiss this alert.',
        alertUrl: `/jobs/${this.record.title}`,
      });
    },
    handleError() {
      this.$refs.modal?.error?.();
      this.$refs.modal?.closeModal?.();
      this.loadingSpinnerStore.hideLocalLoadingSpinner();
      this.selectedCities = [];
    },
    handleCancel() {
      this.$emit('handleJobCityNewCancel');
    },
  },
};
</script>
